// extracted by mini-css-extract-plugin
export default {"wrap":"MyPageMain_wrap__HF+dL","loadingOverlay":"MyPageMain_loadingOverlay__zz2Wy","admin":"MyPageMain_admin__m14j-"};